import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-project-shapes-button',
  templateUrl: 'project-shapes-button.component.svg',
  styleUrls: ['./project-shapes-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectShapesButtonComponent {}
